import { DiplomaStudentsView } from "../Views";

export const DiplomaStudentsPage = (props: { location: any }) => {
	const initialInternshipName = props.location.state?.internshipName;

	return <DiplomaStudentsView initialInternshipName={initialInternshipName} />;
};
